import { Component, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { FunnelHeaderComponent } from './shared/funnel-header/funnel-header.component';
import { ProgressSectionComponent } from './shared/progress-section/progress-section.component';
import { ISalesFunnelLayoutChild } from './shared/sales-funnel-child.module';

@Component({
  selector: 'sales-funnel-layout',
  standalone: true,
  imports: [RouterOutlet, FunnelHeaderComponent, ProgressSectionComponent],
  template: `
    <div class="funnel-wrapper">
      <div class="funnel-container">
        <app-funnel-header [currentStep]="currentStep"></app-funnel-header>
        <app-progress-section [currentStep]="currentStep"></app-progress-section>
        <router-outlet (activate)="onChildActivated($event)"></router-outlet>
      </div>
    </div>
  `,
})
export class SalesFunnelLayout {
  private selectedIndex = signal(1);

  onChildActivated(componentInstance: ISalesFunnelLayoutChild): void {
    this.selectedIndex.set(componentInstance.salesFunnelIndex);
  }

  get currentStep(): number {
    return this.selectedIndex() + 1;
  }
}
